





import Vue from 'vue'
import Mailing from '@/models/mailing/mailing'

export default Vue.extend({
  name: 'PatientIndexColumn',
  props: {
    row: Object as () => Mailing
  }
})
